import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../config/firebase";
import { get, ref } from "firebase/database";
import { useDispatch } from "react-redux";
import { setUser } from "../reduxSlices/auth/authSlice";

export const useAuthInit = () => {
  const [authChecked, setAuthChecked] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        const snapshot = await get(ref(db, `users/${firebaseUser.uid}`));
        if (snapshot.exists()) {
          const userData = snapshot.val();
          dispatch(
            setUser({
              id: firebaseUser.uid,
              email: firebaseUser.email,
              ...userData
            })
          );
        }
      }
      setAuthChecked(true);
    });

    return () => unsub();
  }, [dispatch]);

  return authChecked; // 🔥 this is the key
};